import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "650",
  height: "105",
  viewBox: "0 0 650 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 15.9257C72.2222 -0.866194 144.676 -5.08232 216.667 6.65657C288.889 18.6124 361.111 47.2705 433.333 63.9729C522.934 84.6942 562.656 89.1383 650 90.2578V104.587H613.889C577.778 104.587 505.556 104.587 433.333 104.587C361.111 104.587 288.889 104.587 216.667 104.587C144.444 104.587 72.2222 104.587 36.1111 104.587H0V15.9257Z",
      fill: "#FCFAF8"
    }, null, -1)
  ])))
}
export default { render: render }